module.exports = __webpack_public_path__ + "static/media/5-BiometriaFacialMadit.16df42b2.jpg";